import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronTriangleDownMedium: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-triangle-down-medium, dropdown, caret"><path d="M17.25 9.75H6.75L12 16L17.25 9.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconChevronTriangleDownMedium;
